module.exports = __webpack_public_path__ + "media/images/pro_subscription/carousel3-haircut-fr-FR-60633d1b08956977cf6ab2e0a721e8f2.png";